<template>
  <div class="wrapper">
    <notifications position="bottom right"></notifications>
    <div class="main-panel no-sidebar bg-gradient-sml">
      <dashboard-content class="py-4" />
      <content-footer v-if="!$route.meta.hideFooter" hide-ad></content-footer>
    </div>
  </div>
</template>

<script>
import ContentFooter from "@/views/Layout/Components/ContentFooter.vue";
import DashboardContent from "@/views/Layout/Components/Content.vue";

export default {
  components: {
    DashboardContent,
    ContentFooter
  },
  data() {
    return {};
  }
};
</script>
